import { resolveImagePath } from '@/utils/imageMap';

export function Hero() {
  return (
    <section
      className="relative min-h-[500px] bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `linear-gradient(to right, rgba(139, 0, 0, 0.8) 0%, rgba(139, 0, 0, 0.6) 50%, transparent 100%), url(${resolveImagePath('/images/hero-aircraft.jpg')})`,
      }}
    >
      {/* Main hero content */}
      <div className="container mx-auto px-4 py-16">
        <div className="grid lg:grid-cols-3 gap-8 items-start">
          {/* Services Preview Section - Left sidebar with navigation buttons */}
          <div className="space-y-4">
            <a
              href="/experimental-engines"
              className="block"
            >
              <img
                src={resolveImagePath('/images/btn-experimental.jpg')}
                alt="Experimental Engines"
                className="w-full hover:opacity-90 transition-opacity"
              />
            </a>
            <a
              href="/certified-engines"
              className="block"
            >
              <img
                src={resolveImagePath('/images/btn-certified.jpg')}
                alt="Certified Engines"
                className="w-full hover:opacity-90 transition-opacity"
              />
            </a>
            <a
              href="/parts"
              className="block"
            >
              <img
                src={resolveImagePath('/images/btn-parts.jpg')}
                alt="Parts"
                className="w-full hover:opacity-90 transition-opacity"
              />
            </a>
          </div>

          {/* Center content area */}
          <div className="lg:col-span-2 bg-white/95 backdrop-blur-sm p-8 rounded-lg shadow-lg">
            <h1 className="text-3xl font-bold text-red-600 mb-6">
              WELCOME TO BARRETT PRECISION ENGINES
            </h1>
            <div className="prose prose-gray max-w-none">
              <p className="text-gray-700 leading-relaxed">
                Whether you're a certified aircraft owner, an aerobatic/race pilot in need of a high performance engine or building your 
                dream machine from a kit, you want an engine builder with a fanatical attention to detail, who uses the best materials 
                available and provides you with documented engine performance and reliability. Celebrating over 25 years of service in 
                the aviation industry, Barrett Precision Engines' reputation for providing the highest quality work for many of the world's 
                most successful pilots makes BPE an industry leader in the field of general aviation engines.
              </p>
            </div>

            {/* Quote Request Form */}
            <div className="mt-8 border-t pt-8">
              <h3 className="text-xl font-semibold text-red-600 mb-4">QUOTE REQUEST</h3>
              <form className="space-y-4">
                <div className="grid md:grid-cols-2 gap-4">
                  <input
                    type="text"
                    name="name"
                    placeholder="Name"
                    className="w-full px-4 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-red-500"
                  />
                  <input
                    type="email"
                    name="email"
                    placeholder="Email"
                    className="w-full px-4 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-red-500"
                  />
                </div>
                <div className="grid md:grid-cols-2 gap-4">
                  <input
                    type="text"
                    name="phone"
                    placeholder="Phone"
                    className="w-full px-4 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-red-500"
                  />
                  <input
                    type="text"
                    name="address"
                    placeholder="Address"
                    className="w-full px-4 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-red-500"
                  />
                </div>
                <input
                  type="text"
                  name="country"
                  placeholder="Country"
                  className="w-full px-4 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-red-500"
                />
                <textarea
                  name="message"
                  placeholder="Message"
                  rows={4}
                  className="w-full px-4 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-red-500"
                ></textarea>
                <button
                  type="submit"
                  className="bg-red-600 hover:bg-red-700 text-white px-8 py-2 rounded transition-colors"
                >
                  Submit
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}